module.exports = __webpack_public_path__ + "img/itc-color.5ed876e4.png";